export const prismjsStyles = {
  ':not(pre) > code[class*="language-"]': {
    background: 'gray.200',
    padding: 2,
    whiteSpace: 'pre',
  },
}
